module.exports = "https://coursera_assets.s3.amazonaws.com/images/b833a5af7beafa715dae4737aade15c2.jpg";